import styled, { css } from 'styled-components';

import Callout from '@polyai/ui/components/atoms/Callout';
import { Body } from '@polyai/ui/components/atoms/LegacyText';
import { Text } from '@polyai/ui/components/atoms/Text/Text.styled';
import DefaultPlayAudioCell from '@polyai/ui/components/molecules/TableCell/PlayAudioCell';
import themeColors from '@polyai/ui/styles/config/colors';
import themeSpacing from '@polyai/ui/styles/config/spacing';
export const CustomCallout = styled(Callout)`
  margin-bottom: ${themeSpacing.sm2};
`;

export const InnerWrapper = styled.div`
  display: flex;
  gap: ${themeSpacing.xs3};
  align-items: center;
  padding: ${themeSpacing.xs2} 0;
`;

export const RightButtons = styled.div`
  display: flex;
  gap: ${themeSpacing.xs2};
  align-items: center;
  justify-content: right;
`;

export const LeftButtons = styled.div`
  display: flex;
  gap: ${themeSpacing.xs2};
  align-items: center;
  padding-top: ${themeSpacing.sm1};
`;

export const VoiceInfo = styled.div`
  display: flex;
  flex: 1;
  gap: ${themeSpacing.xs2};
  align-items: center;
`;

export const Percentage = styled(props => <Text {...props} as="span" />)<{
  $disabled?: boolean;
}>`
  ${({ $disabled }) =>
    $disabled &&
    css`
      color: ${themeColors.textDisabled};
    `};
`;

export const DropdownTrigger = styled.span`
  display: flex;
`;

export const Dropdown = styled.div`
  height: 200px;
`;

export const VoiceName = styled(Body)<{ $disabled?: boolean }>`
  ${({ $disabled }) =>
    $disabled &&
    css`
      color: ${themeColors.textDisabled};
    `};
`;

export const Tags = styled.div`
  display: flex;
  gap: ${themeSpacing.xs1};
  align-items: center;
  margin-left: ${themeSpacing.xs2};
`;

export const IconWrapper = styled.button`
  display: flex;
  align-items: center;

  &:disabled {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const Dialect = styled.span`
  color: ${themeColors.textHelper};
`;

export const PlayAudioCell = styled(DefaultPlayAudioCell)<{
  $noCircle?: boolean;
}>`
  flex-grow: 0;
  flex-shrink: 1;

  button {
    width: ${themeSpacing.sm4};
    height: ${themeSpacing.sm4};
    ${({ $noCircle }) =>
      !$noCircle &&
      css`
        border: 1px solid ${themeColors.borderSubtle};
        border-radius: ${themeSpacing.radiusFull};
      `}
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: ${themeSpacing.xs2};
  align-items: center;
`;
